/**
 * This script handles the programmatic changing of the opponent label in index.html
 */

const uscSchedule = [
    {
        id: "North Carolina",
        date: new Date("August 30, 2019")
    },
    {
        id: "Charleston So.",
        date: new Date("September 07, 2019")
    },
    {
        id: "Alabama",
        date: new Date("September 14, 2019")
    },
    {
        id: "Missouri",
        date: new Date("September 21, 2019")
    },
    {
        id: "Kentucky",
        date: new Date("September 28, 2019")
    },
    {
        id: "Georgia",
        date: new Date("October 12, 2019")
    },
    {
        id: "Florida",
        date: new Date("October 19, 2019")
    },
    {
        id: "Tennessee",
        date: new Date("October 26, 2019")
    },
    {
        id: "Vanderbilt",
        date: new Date("November 02, 2019")
    },
    {
        id: "App. State",
        date: new Date("November 09, 2019")
    },
    {
        id: "Texas A&M",
        date: new Date("November 16, 2019")
    },
    {
        id: "Clemson",
        date: new Date("November 30, 2019")
    }
];

let output = "";

const awayTeam = document.querySelector(".hero__label--away"),
    currentDate = EasternOffset(new Date()),
    cd = 24 * 60 * 60 * 1000;

function EasternOffset(curDate) {
    let userOffset = curDate.getTimezoneOffset() * 60 * 1000;
    let easternOffset = 4 * 60 * 60 * 1000;
    let newTime = new Date(curDate.getTime() - (easternOffset - userOffset));
    return newTime.getTime();
}

for (game of uscSchedule) {
    // Subtract the game date in miliseconds from the current time in miliseconds.
    let t = currentDate - game.date;
    // Divide the outcome by number of days calc (cd).
    let d = Math.floor(t / cd);
    // If the number of days is negative, set the game ID & break out.
    if (d <= 0) {
        awayTeam.innerHTML = game.id;
        break;
    }
}
